var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 894,
    height: 1118,
    viewBox: "0 0 894 1118",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M860.767 302.715L591.092 33.0396C570.433 12.3812 541.958 0.65625 512.367 0.65625H112.042C50.625 0.65625 0.933346 50.9062 0.933346 112.323L0.375 1005.66C0.375 1067.07 50.0667 1117.32 111.483 1117.32H782.042C843.458 1117.32 893.708 1067.07 893.708 1005.66V381.998C893.708 352.406 881.983 323.931 860.767 302.715ZM603.375 726.49H502.875V893.99C502.875 924.698 477.75 949.823 447.042 949.823C416.333 949.823 391.208 924.698 391.208 893.99V726.49H291.267C266.142 726.49 253.858 696.34 271.725 679.031L428.058 523.256C439.225 512.648 456.533 512.648 467.7 523.256L623.475 679.031C640.225 696.34 627.942 726.49 603.375 726.49ZM558.708 391.49C528 391.49 502.875 366.365 502.875 335.656V84.4062L809.958 391.49H558.708Z",
    fill: "#CA3657"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.72878ff5fa292dee8b5aecff704d3bcf.svg";
export { ForwardRef as ReactComponent };